import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconBlock = ({ color = 'var(--color-accent-3)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.99995 0.699951C5.75393 0.699951 4.53589 1.06944 3.49986 1.76169C2.46383 2.45395 1.65635 3.43787 1.17951 4.58905C0.702681 5.74022 0.57792 7.00694 0.821007 8.22902C1.06409 9.4511 1.66411 10.5737 2.54518 11.4547C3.42625 12.3358 4.5488 12.9358 5.77089 13.1789C6.99297 13.422 8.25969 13.2972 9.41086 12.8204C10.562 12.3436 11.546 11.5361 12.2382 10.5C12.9305 9.46401 13.3 8.24597 13.3 6.99995C13.3 5.32909 12.6362 3.72666 11.4547 2.54518C10.2732 1.3637 8.67082 0.699951 6.99995 0.699951ZM10.5 7.69995H3.49995V6.29995H10.5V7.69995Z"
                fill={color}
            />
        </svg>
    </div>
);

export default IconBlock;
